import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalService } from './global.service';
import { Globals } from '../models/globals.model';
import { map } from 'rxjs/operators';
import { TenantService } from './tenant.service';
import { AppConstants } from '../app.constants';

@Injectable({
  providedIn: 'root'
})
export class WorkflowService {

  apiUri: string;
  flowsheetUri: string;
  graphUri: string;
  gapApiUri: string;
  monitoringUri: string;
  modelApiUri: string;
  formulaListUri: string;
  platformAdminUri: string;
  phtHeaders = new HttpHeaders({
    'Accept': '*/*',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Headers': 'x-access-token,Content-Type',
    'Access-Control-Allow-Methods': 'DELETE, POST, GET, OPTIONS',
  });

  getFlowSheetsListApi = "api/FlowsheetBuilder/GetFlowSheets";
  getWorkflowListApi = "api/Component/GetWorkflowList";
  UpdateWorkflowStatusApi = "api/Component/UpdateWorkflowStatus";
  getMonitoringDataList = "api/CriteriaConfiguration/get";
  getGap_AnalysisDataList = "api/gapconfiguration/get";
  getDurationList = "api/duration/get";
  getDataSourceList = "api/Datasource/get";
  getCriteriaList = "api/ThresholdType/get";
  deleteWorkflowApi = "api/Component/DeleteWorkflow";
  getFlowSheetsByModelDetailsApi = "api/FlowsheetBuilder/GetFlowsheetsByModelDetails";
  saveWorkflowApi = "api/Component/CreateWorkflow";
  getWorkFlowDataById = "api/Component/GetWorkflowDetail";
  getDataSourcesApi = "api/FlowsheetBuilder/GetDataSources";
  getDataSourceParametersApi = "api/FlowsheetBuilder/GetDataSourceParameters";
  getFlowSheetRunsListApi = "api/FlowsheetBuilder/GetFlowsheetRunsList";
  getFlowSheetRunDetailsApi = "api/FlowsheetBuilder/GetFlowsheetRunDetails";
  runFlowSheetApi = "api/FlowsheetBuilder/Run";
  getLatestRunDetailsApi = "api/FlowsheetBuilder/GetLatestRunDetails";
  getWorkflowReport = "api/Component/WorkflowRunReport/";
  getParamList = "api/rawtags/getdistincttagsbydatasourceid/";
  getCustomCompParametersApi = "api/Component/GetParameterList";
  getCustomComponentListApi = 'api/Component/GetCustomComponentData';
  getAvailalbleFunctionListApi = 'api/Component/GetCustomFunctionsByTenantId';
  authCodeApi = 'api/authCode';
  staticBpmnUrl = '/assets/bpmn/initial.bpmn';
  deleteCustomComponentApi = "api/Component/DeleteModelMasterData";
  getComponentInputParametersApi = "api/Component/GetComponentInputParameters";
  getComponentOutputParametersApi = "api/Component/GetComponentOutputParameters";
  getEditComponentParameterList = 'api/Component/GetCustomParameterList';
  /**Scheduler related APIs*/
  getListTimerTypeApi = "api/Component/ListTimerType";
  getListDataSourceApi = "api/Component/GetByTenant";
  getListFrequencyUnitApi = "api/Component/ListFrequencyUnit";
  getFormulaListApi = "KPIFormulaBuilder/GetFormulas";
  getGapCollectionList = "api/Collection/getAll";
  getCollectionList = 'api/MonitoringCriteriaCollection/get';
  tokenApi = "api/Component/getToken";
  saveModelApi = "api/Component/GetParameterMasterByComponentName";
  saveFunctionDataApi = "api/Component/SaveCustomFunction";
  getComponentDataApi = "api/Component/GetCustomComponentDataByComponentId";
  getUsedCustomFunctionApi = "api/Component/CheckCustomComponentIsAlreadyUsedInWorkflow";

  constructor(private readonly globals: Globals, private readonly http: HttpClient, private readonly globalService: GlobalService,
    private readonly tenantService: TenantService) {
    this.apiUri = this.globals.config.platformHubApi_client_resourceUri;
    this.flowsheetUri = this.globals.config.flowsheetApi_client_resourceUri;
    this.gapApiUri = this.globals.config.gapAnalysisApi_client_resourceUri;
    this.monitoringUri = this.globals.config.monitoringApi_client_resourceUri;
    this.modelApiUri = this.globals.config.modelManagementApi_client_resourceUri;
    this.graphUri = this.globals.config.graphApi_client_resourceUri;
    this.formulaListUri = this.globals.config.platformFoundationApi_client_resourceUri;
    this.platformAdminUri = this.globals.config.platformAdminApi_client_resourceUri;
  }

  getToken() {
    return this.http.get(this.apiUri + this.tokenApi);
  }

  getWorkflowList() {
    return this.http.get(this.apiUri + this.getWorkflowListApi);
  }

  getCustomComponentList() {
    return this.http.get(this.apiUri + this.getCustomComponentListApi);
  }

  /**
   * calls put method and returns result recived
   * @param workflowId workflow id to be updated
   * @param workflowStatus workflow status to be updated
   */
  updateWorflowStatus(workflowId, workflowStatus) {
    return this.http.put(this.apiUri + this.UpdateWorkflowStatusApi + '/' + workflowId + '/' + workflowStatus, null);
  }

  getFlowSheetsList() {
    return this.http.get(this.flowsheetUri + this.getFlowSheetsListApi);
  }

  getFormulaList() {
    return this.http.get(this.formulaListUri + this.getFormulaListApi).pipe(
      map((res: any[]) => {
        const data = res.map(obj => ({
          name: obj.formulaId
        }));
        return data;
      })
    );;
  }

  getFlowData(id) {
    let params = { id: id };
    return this.http.get(this.apiUri + this.getWorkFlowDataById, {
      params: params
    });
  }

  getDataListDetails(componentName) {
    let params = { componentName: componentName };
    if (componentName == this.globalService.monitoringComponentName) {
      return this.http.get(this.monitoringUri + this.getMonitoringDataList, {
        params: params
      });
    } else {
      return this.http.get(this.gapApiUri + this.getGap_AnalysisDataList);
    }
  }

  getDuration() {
    return this.http.get(this.gapApiUri + this.getDurationList);
  }

  getDataSource() {
    return this.http.get(this.monitoringUri + this.getDataSourceList);
  }

  getCriteriaType() {
    return this.http.get(this.monitoringUri + this.getCriteriaList);
  }

  getCustomCompParamList(edit, functionName) {
    if (edit) {
      let params = { id: functionName };
      return this.http.get(this.apiUri + this.getEditComponentParameterList, {
        params: params
      });
    } else {
      let params = { componentName: functionName };
      return this.http.get(this.apiUri + this.getCustomCompParametersApi, {
        params: params
      });
    }
  }

  deleteWorkflow(workflowId) {
    let params = { workflowId: workflowId };
    return this.http.delete(this.apiUri + this.deleteWorkflowApi, {
      params: params
    });
  }

  deleteCustomComponent(customComponentId) {
    let params = { componentId: customComponentId };
    return this.http.delete(this.apiUri + this.deleteCustomComponentApi, {
      params: params
    });
  }

  loadBpmn() {
    const url = this.staticBpmnUrl;
    return this.http.get(url, {
      headers: { observe: 'response' }, responseType: 'text'
    })
  }

  getAvailalbleFunctionList() {
    let tenantFunctionId = this.tenantService.getCurrentTenant().tenantId;
    return this.http.get(this.apiUri + this.getAvailalbleFunctionListApi + '?TenantId=' + tenantFunctionId);
  }

  saveWorkflow(workflowData) {
    return this.http.post<any>(this.apiUri + this.saveWorkflowApi, workflowData);
  }

  getDataSources() {
    return this.http.get(this.flowsheetUri + this.getDataSourcesApi);
  }

  getDataSourceParameters(dataSourceId) {
    let params = { dataSourceId: dataSourceId };
    return this.http.get(this.flowsheetUri + this.getDataSourceParametersApi, {
      params: params
    });
  }

  getFlowsheetRunsList(flowSheetId) {
    let params = { flowSheetId: flowSheetId };
    return this.http.get(this.apiUri + this.getFlowSheetRunsListApi, {
      params: params
    });
  }

  initiateNewRun(runReqData) {
    return this.http.post<any>(this.apiUri + this.runFlowSheetApi, runReqData);
  }

  public loadReportData(workflowId) {
    return this.http.get(this.apiUri + this.getWorkflowReport + workflowId);
  }

  getInputParameters(componentId) {
    let params = { componentId: componentId };
    return this.http.get(this.apiUri + this.getComponentInputParametersApi, {
      params: params
    });
  }

  getOutPutarameters(componentId) {
    let params = { componentId: componentId };
    return this.http.get(this.apiUri + this.getComponentOutputParametersApi, {
      params: params
    });
  }

  getListTimerType() {
    return this.http.get(this.apiUri + this.getListTimerTypeApi);
  }

  getListDataSource() {
    const tenantId = this.tenantService.getCurrentTenant().tenantId;
    return this.http.get(this.platformAdminUri + this.getListDataSourceApi +
      '?TenantId=' + tenantId + '&componentId=' + AppConstants.componentId);
  }

  getListFrequencyUnit() {
    return this.http.get(this.apiUri + this.getListFrequencyUnitApi);
  }

  getCollectionListDetails(componentName) {
    if (componentName === "Gap_Analysis") {
      return this.http.get(this.gapApiUri + this.getGapCollectionList);
    } else {
      return this.http.get(this.monitoringUri + this.getCollectionList);
    }
  }

  getModelName(functionName) {
    return this.http.get(this.apiUri + this.saveModelApi +
      '?componentName=' + functionName);
  }

  saveFinalFunctionData(functionData) {
    return this.http.post<any>(this.apiUri + this.saveFunctionDataApi, functionData);
  }

  getCustomComponentData(componentId) {
    let params = { componentId: componentId };
    return this.http.get(this.apiUri + this.getComponentDataApi, {
      params: params
    });
  }

  getUsedCustomFunction(componentId) {
    let params = { componentId: componentId };
    return this.http.get(this.apiUri + this.getUsedCustomFunctionApi, {
      params: params
    });
  }

}
